<template>
  <div :class="`col-md-${width} form-group`">
    <div class="checkbox-wrapper">
      <label :for="name"> {{ label }} <span v-if="required">*</span> </label>
      <input type="checkbox" :id="name" :name="name" :disabled="disabled" :checked="value" @change="$emit('input', $event.target.checked)" />
    </div>
    <p v-if="help" class="help-block">{{ help }}</p>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    name: { type: String, required: true },
    label: { type: String, required: true },
    help: String,
    value: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.checkbox-wrapper {
  display: flex;
  align-items: center;
}
.checkbox-wrapper label {
  padding-right: 8px;
  margin-bottom: 0;
  cursor: pointer;
}
.checkbox-wrapper input {
  margin-top: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/checkbox.vue